/* Blueprint Beauty — theme behaviour.
   Everything reads from section settings, so nothing here needs editing
   when content changes in the theme editor. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.BB_NO_ANIM === true;
  var noAuto = window.BB_NO_AUTOPLAY === true;
  var timers = [];

  /* Bind each element once. init() re-runs on every theme-editor section
     load, and without this every listener and timer stacks up. */
  function once(el, key) {
    if (!el) return false;
    var k = 'bb' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  function clearTimers() {
    timers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
    timers = [];
  }

  function slug(s) {
    return String(s || '').toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  /* ── fade sections in on scroll ── */
  function reveal() {
    var els = [].slice.call(document.querySelectorAll('.rv')).filter(function (e) { return once(e, 'Rv'); });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ── sticky mobile bar swaps intent past the menu ── */
  function bookbar() {
    var bar = document.getElementById('bookbar');
    if (!bar || !once(bar, 'Bar')) return;
    var link = bar.querySelector('a'), cap = bar.querySelector('.cap');
    var menu = document.getElementById(bar.dataset.watch || 'book');
    if (!menu || !link || !cap || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          cap.textContent = bar.dataset.nearCap || '';
          link.textContent = bar.dataset.nearLabel || '';
          link.setAttribute('href', '#' + (bar.dataset.watch || 'book'));
        } else {
          cap.textContent = bar.dataset.farCap || '';
          link.textContent = bar.dataset.farLabel || '';
          link.setAttribute('href', bar.dataset.farLink || '#');
        }
      });
    }, { threshold: 0.15 }).observe(menu);
  }

  /* ── brow map drag reveal ── */
  function browMap() {
    var rv = document.getElementById('reveal');
    if (!rv || !once(rv, 'Rev')) return;
    var set = function (p) { rv.style.setProperty('--split', Math.max(4, Math.min(96, p)) + '%'); };
    var mv = function (e) { var r = rv.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    var down = false;
    rv.addEventListener('pointerdown', function (e) { down = true; rv.setPointerCapture(e.pointerId); mv(e); });
    rv.addEventListener('pointermove', function (e) { if (down || e.pointerType === 'mouse') mv(e); });
    rv.addEventListener('pointerup', function () { down = false; });
    rv.addEventListener('pointercancel', function () { down = false; });
    set(50);
    if (reduce || !('IntersectionObserver' in window)) return;
    var shown = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || shown) return;
        shown = true;
        var t0 = null;
        requestAnimationFrame(function loop(ts) {
          if (down) return;
          if (t0 === null) t0 = ts;
          var k = (ts - t0) / 2400;
          if (k >= 1) { set(50); return; }
          set(50 + 27 * Math.sin(k * Math.PI * 2));
          requestAnimationFrame(loop);
        });
      });
    }, { threshold: 0.4 }).observe(rv);
  }

  /* ── phones: each flips between its own two photos ── */
  function phones() {
    var wrap = document.querySelector('.dev');
    if (!wrap) return;
    [].slice.call(wrap.querySelectorAll('.phone')).forEach(function (p, n) {
      if (!once(p, 'Ph')) return;
      var imgs = [].slice.call(p.querySelectorAll('.phone__scr img'));
      if (imgs.length < 2) return;
      var i = 0;
      var step = function () {
        imgs[i].classList.remove('on');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('on');
      };
      p.addEventListener('click', step);
      if (reduce || noAuto) return;
      timers.push(setTimeout(function () { step(); timers.push(setInterval(step, 5400)); }, 1200 + n * 1400));
    });
  }

  /* ── tabbed lists ── */
  function tabs() {
    [].slice.call(document.querySelectorAll('.tabs')).forEach(function (group) {
      if (!once(group, 'Tb')) return;
      var btns = [].slice.call(group.querySelectorAll('.tab'));
      btns.forEach(function (t, i) {
        t.addEventListener('click', function () {
          btns.forEach(function (x, n) {
            x.setAttribute('aria-selected', x === t ? 'true' : 'false');
            var panel = document.getElementById('tp' + n);
            if (panel) panel.hidden = (x !== t);
          });
        });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var nx = btns[(i + d + btns.length) % btns.length];
          nx.focus(); nx.click();
        });
      });
    });
  }

  /* highlight the matching row in the service menu.
     Works with both menu styles — the classic list rows and the photo
     cards both carry data-key. */
  function clearHits() {
    [].forEach.call(document.querySelectorAll('#menu [data-key]'), function (x) { x.classList.remove('hit'); });
  }
  function markHit(title) {
    clearHits();
    var match = document.querySelector('#menu [data-key="' + slug(title) + '"]');
    if (match) match.classList.add('hit');
  }

  /* ── three questions ── */
  function guide() {
    var quiz = document.getElementById('quiz');
    if (!quiz || !once(quiz, 'Qz')) return;
    var steps = [].slice.call(quiz.querySelectorAll('.step'));
    var bars = [].slice.call(quiz.querySelectorAll('.qz__bar i'));
    var res = document.getElementById('res');
    var nav = document.getElementById('qnav');
    var back = document.getElementById('back');
    var count = document.getElementById('qc');
    if (!steps.length || !res) return;

    var results = [];
    var raw = document.getElementById('bb-results');
    if (raw) { try { results = JSON.parse(raw.textContent) || []; } catch (e) { results = []; } }

    var answers = [], step = 0;

    function show(i) {
      step = i;
      steps.forEach(function (s, n) { s.classList.toggle('on', n === i); });
      bars.forEach(function (b, n) { b.classList.toggle('on', n <= i); });
      if (back) back.hidden = (i === 0);
      if (count) count.textContent = 'Question ' + (i + 1) + ' of ' + steps.length;
      res.classList.remove('on');
      if (nav) nav.hidden = false;
    }

    function finish() {
      var causes = answers.map(function (a) { return a && a.cause ? a.cause : ''; }).filter(Boolean).join(' ');
      var pick = null;
      for (var i = answers.length - 1; i >= 0; i--) {
        if (answers[i] && answers[i].result !== null && answers[i].result !== undefined && !isNaN(answers[i].result)) {
          pick = answers[i].result; break;
        }
      }
      var r = (pick !== null && results[pick]) ? results[pick] : results[0];
      if (!r) return;

      var t = document.getElementById('rT'), m = document.getElementById('rM');
      var c = document.getElementById('rCause'), b = document.getElementById('rB');
      if (t) t.textContent = r.phone ? (quiz.dataset.phoneTitle || r.title) : r.title;
      if (m) m.textContent = r.phone ? 'No appointment needed' : (r.meta || '');
      if (c) { c.textContent = causes; c.hidden = !causes; }
      if (b) b.textContent = r.phone ? (quiz.dataset.phoneText || r.text) : r.text;

      var btn = document.getElementById('rBook');
      if (btn) {
        var phoneHref = quiz.dataset.phone || '';
        if (r.phone) {
          /* no number saved yet — send them to the contact block rather
             than a dead tel: link */
          btn.href = (phoneHref && phoneHref !== 'tel:') ? phoneHref : '#ask';
          btn.textContent = quiz.dataset.phoneCta || 'Call or text';
          btn.removeAttribute('target');
          btn.removeAttribute('rel');
        } else {
          btn.href = r.link || '#book';
          btn.textContent = 'Book this';
          btn.target = '_blank';
          btn.rel = 'noopener';
        }
      }

      steps.forEach(function (s) { s.classList.remove('on'); });
      bars.forEach(function (x) { x.classList.add('on'); });
      res.classList.add('on');
      if (nav) nav.hidden = true;
      if (!r.phone) markHit(r.title); else clearHits();
    }

    [].forEach.call(quiz.querySelectorAll('.opt'), function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(btn.dataset.q, 10);
        answers[q] = {
          cause: btn.dataset.cause || '',
          result: btn.dataset.result !== undefined ? parseInt(btn.dataset.result, 10) : null
        };
        if (step < steps.length - 1) show(step + 1); else finish();
      });
    });
    if (back) back.addEventListener('click', function () { if (step > 0) show(step - 1); });
    var again = document.getElementById('again');
    if (again) again.addEventListener('click', function () {
      answers = [];
      clearHits();
      show(0);
    });
    if (count) count.textContent = 'Question 1 of ' + steps.length;
  }

  /* ── instagram stories ── */
  function stories() {
    var wrap = document.getElementById('story');
    if (!wrap || !once(wrap, 'St')) return;
    var slides = [].slice.call(wrap.querySelectorAll('.story__img'));
    var bars = [].slice.call(wrap.querySelectorAll('.story__bars i'));
    var rings = [].slice.call(document.querySelectorAll('.ring'));
    var cap = document.getElementById('storycap');
    var sec = document.querySelector('.ig');
    if (!slides.length) return;
    var i = 0, timer = null, DUR = 5000;

    function paint() {
      slides.forEach(function (el, n) { el.classList.toggle('on', n === i); });
      rings.forEach(function (r, n) { r.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      bars.forEach(function (b, n) {
        b.classList.remove('live', 'done');
        var fill = b.querySelector('b');
        if (fill) fill.style.width = '';
        if (n < i) b.classList.add('done');
      });
      if (bars[i]) { void bars[i].offsetWidth; if (!reduce && !noAuto) bars[i].classList.add('live'); }
      if (cap) cap.textContent = slides[i].dataset.cap || '';
    }
    function go(n) { i = (n + slides.length) % slides.length; paint(); run(); }
    function run() { if (reduce || noAuto) return; clearTimeout(timer); timer = setTimeout(function () { go(i + 1); }, DUR); timers.push(timer); }
    function stop() { clearTimeout(timer); if (sec) sec.classList.add('paused'); }
    function start() { if (sec) sec.classList.remove('paused'); run(); }

    var next = document.getElementById('nextS'), prev = document.getElementById('prevS');
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    rings.forEach(function (r) { r.addEventListener('click', function () { go(parseInt(r.dataset.i, 10)); }); });
    wrap.addEventListener('pointerdown', stop);
    wrap.addEventListener('pointerup', start);

    if (sec && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!seen) { seen = true; paint(); } start(); } else { stop(); }
        });
      }, { threshold: 0.25 }).observe(sec);
    } else { paint(); start(); }
  }

  function init() { reveal(); bookbar(); browMap(); phones(); tabs(); guide(); stories(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* re-run when a section is edited in the theme customiser */
  document.addEventListener('shopify:section:load', function () { clearTimers(); init(); });
  document.addEventListener('shopify:section:unload', clearTimers);
})();
